export default __webpack_public_path__ + "static/media/place_holder_image.e709ba61.svg";